<div class='pt-no-active-module'>
  <ng-container [ngSwitch]='primatooEntity'>

    <ng-container *ngSwitchCase='PrimatooEntity.WORKSPACE'>
      <div class='msg-container'>
        <pt-icon
          [iconType]='IconType.SVG'
          [key]='"workspace.svg"'
          [size]='100'
          class="mb-4"
        ></pt-icon>

        <div [innerHTML]='"MESSAGE.NO_ACTIVE_MANAGEMENT_WORKSPACE" | translate'
             class='text-muted'
        ></div>

        <a class='btn btn-sm btn-link mt-3 d-flex align-items-end'
           href='mailto:{{email}}?subject=[Primatoo] Request information about Management Workspace module'>
          <pt-icon
            [iconType]='IconType.IONIC_ICON'
            [key]='IconOpen'
            [size]='16'
          ></pt-icon>
          {{ "BUTTON.CONTACT" | translate }}
        </a>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase='PrimatooEntity.DATABREACH'>
      <div class='msg-container'>
        <pt-icon
          [iconType]='IconType.SVG'
          [key]='"data-breach.svg"'
          [size]='100'
          class="mb-4"
        ></pt-icon>

        <div [innerHTML]='"MESSAGE.NO_ACTIVE_MANAGEMENT_DATABREACH" | translate'
             class='text-muted'
        ></div>

        <a class='btn btn-sm btn-link mt-3 d-flex align-items-end'
           href='mailto:{{email}}?subject=[Primatoo] Request information about Management Data Breach module'>
          <pt-icon
            [iconType]='IconType.IONIC_ICON'
            [key]='IconOpen'
            [size]='16'
          ></pt-icon>
          {{ "BUTTON.CONTACT" | translate }}
        </a>
      </div>
    </ng-container>


    <ng-container *ngSwitchCase='PrimatooEntity.NONE'>
      <div class='msg-container'>
        <pt-icon
          [iconType]='IconType.SVG'
          [key]='"ai.svg"'
          [size]='100'
        ></pt-icon>

        <div [innerHTML]='"MESSAGE.NO_ACTIVE_MODULE" | translate'
             class='text-muted'
        ></div>

        <a class='btn btn-sm btn-link mt-3 d-flex align-items-end'
           href='mailto:{{email}}?subject=[Primatoo] Request information about Generic module'>
          <pt-icon
            [iconType]='IconType.IONIC_ICON'
            [key]='IconOpen'
            [size]='16'
          ></pt-icon>
          {{ "BUTTON.CONTACT" | translate }}
        </a>
      </div>
    </ng-container>
  </ng-container>
</div>
